module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    on: {
      "show": _vm.show,
      "hide": _vm.hide
    }
  }, [_c('div', {
    staticClass: "background"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "home-frame"
  }, [_c('img', {
    staticClass: "show-menu",
    attrs: {
      "src": require("@/assets/images/menu_button.svg")
    },
    on: {
      "click": _vm.showMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-contents"
  }, [_c('v-ons-page', [_c('v-ons-navigator', {
    attrs: {
      "page-stack": _vm.pageStack,
      "options": _vm.options
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ece14fc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/index.vue
// module id = 848
// module chunks = 0